import { Spin as _Spin, SpinProps as _SpinProps } from 'antd'

type SpinProps = _SpinProps

export default function Spin(props: SpinProps) {
  return <_Spin {...props} />
}
